import { useStore } from 'effector-react'

import {
  $demoContestList,
  $totalCountOfDemoContestList,
  getDemoContestList,
  demoContestListMounted,
} from './model'
import { DemoContestRequest } from './types'

export const useDemoContestList = () => {
  const demoContestList = useStore($demoContestList)

  const loading = useStore(getDemoContestList.pending)

  const totalCountOfDemoContestList = useStore($totalCountOfDemoContestList)

  const onChangeDemoContestList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: DemoContestRequest) => {
    demoContestListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    demoContestList,
    totalCountOfDemoContestList,
    loading,
    onChangeDemoContestList,
  }
}
